import { useDispatch } from 'react-redux';
import { createZodFormResolver, FormTextareaField, lt, Form } from '@mews/framework';
import { Button, Stack } from '@optimus-web/core';
import { AccountNoteCustomerClassifications } from '@mews-commander/data-access';
import { EnumSelectField } from '@mews-commander/form';
import { WithOwnerId } from '@mews-commander/types';
import { addAccountNote } from '../actions';
import { accountNoteFormSchema, AccountNoteFormValues, FieldNames } from './schema';

interface AccountNoteFormProps extends WithOwnerId {
    onClose: () => void;
}
export const AccountAddNoteForm = ({ ownerId, onClose }: AccountNoteFormProps) => {
    const dispatch = useDispatch();
    const resolver = createZodFormResolver<AccountNoteFormValues>(accountNoteFormSchema);
    const defaultValues = {
        [FieldNames.content]: '',
        [FieldNames.classification]: AccountNoteCustomerClassifications.General,
    } satisfies AccountNoteFormValues;

    const handleAddNote = (formData: AccountNoteFormValues) => {
        dispatch(addAccountNote({ content: formData.content, classification: formData.classification }, ownerId, ''));
        onClose();
    };

    return (
        <Form onSubmit={handleAddNote} resolver={resolver} defaultValues={defaultValues}>
            {({ submit }) => (
                <Stack vertical spacing="200">
                    <EnumSelectField
                        name={FieldNames.classification}
                        enumClass={AccountNoteCustomerClassifications}
                        enumPrefix="AccountNoteCustomerClassifications"
                        label={lt('Classification')}
                        placeholder={lt('AccountNoteClassificationSelectFieldPlaceholder')}
                        required
                    />

                    <FormTextareaField
                        name={FieldNames.content}
                        label={lt('Content')}
                        placeholder={lt('AccountNoteContentFieldPlaceholder')}
                        size="small"
                        required
                    />
                    <Stack alignment="end">
                        <Button variant="primary" onClick={submit} type="submit">
                            {lt('Save')}
                        </Button>
                    </Stack>
                </Stack>
            )}
        </Form>
    );
};
